import { Component } from "@angular/core";
import { ModalBase } from "src/app/model/modal-base";
import { Router } from "@angular/router";

@Component({
    selector: 'app-nets-payment-cancelled-modal',
    templateUrl: 'nets-payment-cancelled-modal.component.html'
})
export class NetsPaymentCancelledModalComponent extends ModalBase
{
    private readonly router: Router;

    public constructor(router: Router) {
        super();
        this.router = router;
    }

    public onCancelClick() {

        // http://ddkweb/nets-payment-return?statuscode=1&status=cancelled
        this.close();
        this.router.navigate(['/kvittering']);
    }
}
